module.exports = __webpack_public_path__ + "img/SER-B-1-I.f90ab706.png";